import styled from "styled-components";

type FormFieldProps = {
  type?: string;
  id: string;
  name: string;
  label?: string;
  placeholder?: string;
  value: string | number | null;
  onChange: React.ChangeEventHandler<any>;
  maxLength?: number;
  minLength?: number;
  variant?: "input" | "select" | "textarea";
  options?: {
    name: string | null;
    id: number;
  }[];
  required?: boolean;
};

const FormField = ({
  type = "string",
  id,
  name,
  label,
  placeholder,
  value,
  onChange,
  maxLength,
  minLength,
  variant = "input",
  options,
  required,
}: FormFieldProps) => {
  return (
    <>
      {label && label?.length > 0 && (
        <StyledLabel htmlFor={id}>{label}</StyledLabel>
      )}

      {variant === "input" && (
        <StyledInput
          type={type}
          id={id}
          name={name}
          placeholder={placeholder}
          value={value || undefined}
          onChange={onChange}
          maxLength={maxLength}
          minLength={minLength}
          required={required}
        />
      )}

      {variant === "textarea" && (
        <StyledTextarea
          id={id}
          name={name}
          placeholder={placeholder}
          value={value || undefined}
          onChange={onChange}
          maxLength={maxLength}
          minLength={minLength}
          required={required}
          rows={3}
        />
      )}

      {variant === "select" && (
        <StyledSelect
          id={id}
          name={name}
          onChange={onChange}
          defaultValue={options && options[0].id}
        >
          {options?.map((option, index) => (
            <option key={`option_${option.id}_${index}`} value={option.id}>
              {option.name}
            </option>
          ))}
        </StyledSelect>
      )}
    </>
  );
};

const StyledLabel = styled.label``;

const StyledInput = styled.input`
  color: ${({ theme }) => theme.colors.text};
  border-radius: ${({ theme }) => theme.radii.default};
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};
  padding: 10px 15px;
  font-size: ${({ theme }) => theme.fontSize.Input};
  width: 100%;
  outline: none;
`;

const StyledSelect = styled.select`
  color: ${({ theme }) => theme.colors.text};
  border-radius: ${({ theme }) => theme.radii.default};
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};
  padding: 10px 15px;
  font-size: ${({ theme }) => theme.fontSize.Input};
  width: 100%;
  outline: none;
  cursor: pointer;
`;

const StyledTextarea = styled.textarea`
  color: ${({ theme }) => theme.colors.text};
  border-radius: ${({ theme }) => theme.radii.default};
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};
  padding: 10px 15px;
  font-size: ${({ theme }) => theme.fontSize.Input};
  width: 100%;
  outline: none;
`;

export default FormField;
